// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__14vGx","search":"Settings_search__36K8W","filter":"Settings_filter__1PQcn"};